/**
 * iView Admin Pro 业务配置
 * */
import util from '@/libs/util';
import axios from "axios";

const Setting = {
    // Cookies 默认保存时间，单位：天
    cookiesExpires: 1,
    apiBaseURL: axios.defaults.baseURL
};

export default Setting;
